import {
  Box,
  Button,
  Grid,
  Typography,
  Stack,
  Container,
  CssBaseline,
  TextField,
  Alert,
  AlertTitle,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import { FileUpload } from "../../Interface/FileUpload";
import AppHelper from "../../Helper/AppHelper";
import { AppSettings } from "../../AppSettings";
import QueueIcon from "@mui/icons-material/Queue";
import Loader from "../Loader";
import { UploadResult } from "../../Interface/UploadResult";
import UploadIcon from "../../images/download.png";
import "./ImportUsers.css";

function ImportUsers() {
  const [selectedFile, setSelectedFile] = React.useState<FileUpload>({
    name: "",
    type: "",
    size: 0,
    lastModifiedDate: undefined,
  });

  const [isSelected, setIsSelected] = React.useState<boolean>(false);
  const [errors, setErrors] = React.useState<String[]>([]);
  const [success, setSuccesss] = React.useState<String[]>([]);

  const [openLoader, setOpenloader] = React.useState(false);
  const changeHandler = (event: any) => {
    setSelectedFile(event.target.files[0]);
    setIsSelected(true);
  };
  const navigate = useNavigate();
  const handleSubmission = () => {
    setOpenloader(true);
    const formData = new FormData();

    formData.append("File", selectedFile as unknown as Blob);

    let apiUrl = AppSettings.API_URL + "User/ImportUsers";

    fetch(apiUrl, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: "Bearer " + AppHelper.getUser().token,
      },
    })
      .then((response) => response.json())
      .then((result) => {
        if (result) {
          if (result.successes.length > 0) {
            setSuccesss(result.successes);
          }
          if (result.errors.length > 0) {
            setErrors(result.errors);
          }

          setOpenloader(false);
          console.log("Success:", result);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const templateUrl = AppSettings.API_URL + "UsersTemplate.xlsx";


  return (
    <div className="page-container">
      <div className="add-details">
        <Loader value={openLoader}></Loader>
          <Container component="main" maxWidth="md">
            <CssBaseline />
            <Box
              sx={{
                marginTop: 3,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                component="h1"
                variant="h5"
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <SupervisorAccountIcon
                  sx={{ fontSize: 30, marginRight: 1 }}
                ></SupervisorAccountIcon>{" "}
                <b>Import Users</b>{" "}
              </Typography>
            </Box>
            <Stack spacing={2} padding={1} direction="row">
              {errors.length > 0 && (
                <Alert severity="error">
                  <AlertTitle>Error</AlertTitle>
                  {errors.map((error, index) => (
                    <p>{error} </p>
                  ))}
                </Alert>
              )}

              {success.length > 0 && (
                <Alert severity="success">
                  <AlertTitle>Success</AlertTitle>
                  {success.map((msgItem, index) => (
                    <p>{msgItem} </p>
                  ))}
                </Alert>
              )}
            </Stack>
            <Box component="form" noValidate sx={{ mt: 1 }}>
              {" "}
              <Grid item xs={12}>
                {/* <input type="file" name="file" onChange={changeHandler}  /> */}
                <TextField
                  fullWidth
                  type="file"
                  name="file"
                  onChange={changeHandler}
                  variant="outlined"
                />
                {isSelected && (
                  <div>
                    <p>Filename: {selectedFile.name}</p>
                    <p>Filetype: {selectedFile.type}</p>
                    <p>Size in bytes: {selectedFile.size}</p>
                    <p>
                      lastModifiedDate:{" "}
                      {selectedFile.lastModifiedDate?.toLocaleDateString()}
                    </p>
                  </div>
                )}
                <Stack spacing={2} padding={2} direction="row">
                  <Button
                    variant="contained"
                    onClick={handleSubmission}
                    size="medium"
                    startIcon={<QueueIcon />}
                  >
                    Import
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => navigate("/UserList")}
                  >
                    Cancel
                  </Button>
                                  <img src={UploadIcon} className="donwloadTemplateIcon"></img><a href={templateUrl} className="downloadTemplateLink" download="UsersTemplate.xlsx">Download Template</a>
                </Stack>
              </Grid>
            </Box>
          </Container>
      </div>
    </div>
  );
}

export default ImportUsers;
